var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-container"},[(_vm.loading)?_c('div',{staticClass:"loading-overlay",class:_vm.spinnerClass},[_c('b-spinner',{attrs:{"small":"","label":"Loading..."}})],1):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }